/**
 * 团队权限设置模块
 */

import { useState, useEffect } from 'react';
import {
    Modal,
    Input,
    Row,
    Col,
    message,
    Button,
} from 'antd';
import $ from 'jquery';
import {
    PlusOutlined,
    MinusOutlined,
} from '@ant-design/icons';
import {
    UjoinParams,
    AddRequestHeaders,
    setStyle,
} from '../../incs/FunHelper.js';

import CNF from '../../incs/Config.js';

const Entity = (props) => {
    const [messageApi, contextHolder] = message.useMessage();

    const [loading, setLoading] = useState(false);
    const [isRefreshUnselected, setIsRefreshUnselected] = useState(false);
    const [isRefreshSelected, setIsRefreshSelected] = useState(false);
    const [unselectedLists, setUnselectedLists] = useState([]);
    const [selectedLists, setSelectedLists] = useState([]);
    const [unselectedName, setUnselectedName] = useState('');
    const [selectedName, setSelectedName] = useState('');

    const cancel = () => {
        props.setOpen(false);
        setLoading(false);
        setUnselectedLists([]);
        setSelectedLists([]);
        setUnselectedName('');
        setSelectedName('');
    };

    useEffect(() => {
        if (props.open) {
            setIsRefreshUnselected(true);
            setIsRefreshSelected(true);
        }
    }, [props]);


    useEffect(() => {
        /**
         * 获取未选择权限
         */
        const getUnselected = () => {
            let params = {
                'rss': 'groupUnselected',
                'group_ulid': props.record.key,
                'prefix': props.record.groupname.split('-')[1],
                'name': unselectedName
            }
            $.ajax({
                url: `${CNF.api}authoritys${UjoinParams(params)}`,
                headers: AddRequestHeaders(),
                type: 'GET',
                dataType: 'JSON',
            }).done(function (data) {
                if (data.res === 0) {
                    setUnselectedLists(data.dat);
                    setIsRefreshUnselected(false);
                }
            })
        }
        if (isRefreshUnselected) {
            getUnselected();
        }
    }, [props.record, isRefreshUnselected, unselectedName]);


    useEffect(() => {
        /**
         * 获取角色已择权限
         */
        const getSelected = () => {
            var params = {
                'rss': 'groupSelected',
                'group_ulid': props.record.key,
                'prefix': props.record.groupname.split('-')[1],
                'name': selectedName
            }
            $.ajax({
                url: `${CNF.api}authoritys${UjoinParams(params)}`,
                headers: AddRequestHeaders(),
                type: 'GET',
                dataType: 'JSON',
            }).done(function (data) {
                if (data.res === 0) {
                    setSelectedLists(data.dat);
                    setIsRefreshSelected(false);
                }
            })
        }
        if (isRefreshSelected) {
            getSelected();
        }
    }, [props.record, isRefreshSelected, selectedName]);

    /**
     * 添加权限
     * @param {*} item 
     */
    const addAuthority = (item) => {
        setLoading(true);
        $.ajax({
            url: `${CNF.api}groups/${props.record.key}/authority`,
            headers: AddRequestHeaders(),
            type: 'POST',
            dataType: 'JSON',
            data: JSON.stringify({
                'authority_ulid': item['key'],
                'authority_name': item['name'],
            }),
        }).done(function (data) {
            if (data.res === 0) {
                setIsRefreshUnselected(true);
                setIsRefreshSelected(true);
            } else {
                messageApi.error(data.msg, CNF.messageDuration);
            }
        }).always(() => {
            setLoading(false);
        });
    }

    /**
     * 移除权限
     * @param {*} item 
     */
    const removeAuthoritys = (item) => {
        setLoading(true);
        $.ajax({
            url: `${CNF.api}groups/${props.record.key}/authority`,
            headers: AddRequestHeaders(),
            type: 'DELETE',
            dataType: 'JSON',
            data: JSON.stringify({
                'authority_ulid': item['key'],
                'authority_name': item['name'],
            }),
        }).done(function (data) {
            if (data.res === 0) {
                setIsRefreshUnselected(true);
                setIsRefreshSelected(true);
            } else {
                messageApi.error(data.msg, CNF.messageDuration);
            }
        }).always(() => {
            setLoading(false);
        });
    }


    return (
        <>
            {contextHolder}
            <Modal
                width={1080}
                title={'团队权限设置: ' + (props.record ? props.record.groupname : '')}
                open={props.open}
                onCancel={cancel}
                footer={null}
                okButtonProps={{ disabled: loading }}
            >
                <Row>
                    <Col span={11}>
                        <Row>可选权限</Row>
                        <Row style={{ marginTop: CNF.rowMarginTop, }}>
                            <Col span={24}>
                                <Input
                                    onChange={(e) => {
                                        setUnselectedName(e.target.value.replace(/ /g, ''));
                                        if (e.target.value.replace(/ /g, '')) setIsRefreshUnselected(true);
                                    }}
                                    placeholder='权限名'
                                    value={unselectedName}
                                    disabled={false}
                                />
                            </Col>
                        </Row>
                        <div style={setStyle}>
                            {
                                props.open &&
                                unselectedLists.length > 0 &&
                                unselectedLists.map((item) => {
                                    return (
                                        <Row key={item['key']} style={{ width: '100%' }}>
                                            <Col span={20}>{item['name']}</Col>
                                            <Col span={2} offset={2}>
                                                <Button
                                                    color='primary'
                                                    variant='link'
                                                    title={CNF.actionName.ADD}
                                                    icon={<PlusOutlined />}
                                                    style={{ padding: 1 }}
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        addAuthority(item)
                                                    }}
                                                    disabled={loading}
                                                >
                                                </Button>
                                            </Col>
                                        </Row>
                                    )
                                })
                            }
                        </div>
                    </Col>
                    <Col span={11} offset={2}>
                        <Row>已选权限</Row>
                        <Row style={{ marginTop: CNF.rowMarginTop, }}>
                            <Col span={3}>搜索：</Col>
                            <Col span={21}>
                                <Input
                                    onChange={(e) => {
                                        setSelectedName(e.target.value.replace(/ /g, ''));
                                        if (e.target.value.replace(/ /g, '')) setIsRefreshSelected(true);
                                    }}
                                    placeholder='权限名'
                                    value={selectedName}
                                    disabled={false}
                                />
                            </Col>
                        </Row>
                        <div style={setStyle}>
                            {
                                props.open &&
                                selectedLists.length > 0 &&
                                selectedLists.map((item) => {
                                    return (
                                        <Row key={item['key']} style={{ width: '100%' }}>
                                            <Col span={20}>{item['name']}</Col>
                                            <Col span={2} offset={2}>
                                                <Button
                                                    color='primary'
                                                    variant='link'
                                                    title={CNF.actionName.REMOVE}
                                                    icon={<MinusOutlined />}
                                                    style={{ padding: 1 }}
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        removeAuthoritys(item)
                                                    }}
                                                    disabled={loading}
                                                >
                                                </Button>
                                            </Col>
                                        </Row>
                                    )
                                })
                            }
                        </div>
                    </Col>
                </Row>
            </Modal>
        </>
    );
}

export default Entity